import styled from 'styled-components';
import {media} from '../../styles/components/media-queries';
import {CategoryHeaderStyled} from './Category.style';

export const Wrapper = styled.div`
  display: block;
`;

export const CategoryHeader = styled(CategoryHeaderStyled)`
  ${media.small`
    display: none;
  `};
`;

export const Description = styled.section`
  width: 100%;
  font-size: ${props => props.theme.fontSize};
  padding: ${props => props.theme.padding};
  background-color: ${props => props.theme.primaryBackground};
  color: ${props => props.theme.quaternaryColor};
`;



// WEBPACK FOOTER //
// ./components/Categories/InfoSection.style.js